import {useTranslation} from 'react-i18next';
import {PropsWithChildren, useEffect} from 'react';
import styled from 'styled-components';
import Button from './Button';

type ModalProps = PropsWithChildren<{
  closeModal: React.MouseEventHandler<HTMLElement>;
}>;

export default function Modal({children, closeModal}: ModalProps) {
  const {t} = useTranslation();
  useEffect(() => {
    document.querySelector('body')?.classList.add('noscroll');

    return () => {
      document.querySelector('body')?.classList.remove('noscroll');
    };
  });

  return (
    <Container>
      <Inner>
        <Body>
          <Title>{t('game.istructions.title')}</Title>
          <Content>{children}</Content>
          <Button onClick={closeModal}>{t('game.istructions.submit')}</Button>
        </Body>
      </Inner>
    </Container>
  );
}

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem;
  padding-top: 10vh;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: auto;

  @media ${(props) => props.theme.breakpoints.phone} {
    padding: 1rem;
    padding-top: 20px;
  }
`;

const Inner = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  padding: 3rem;
  border-radius: 10px;
  width: 100%;
  max-width: 800px;

  @media ${(props) => props.theme.breakpoints.phone} {
    padding: 1rem;
  }
`;

const Body = styled.div`
  & > * + * {
    margin-top: 2rem;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Content = styled.div`
  font-size: 1.2rem;
  line-height: 1.4;
  width: 100%;
  padding-bottom: 2rem;
  border-bottom: solid 1px ${(props) => props.theme.colors.gray300};

  @media ${(props) => props.theme.breakpoints.phone} {
    font-size: 1rem;
  }
`;

const Title = styled.h2`
  margin: 0;
  display: block;
  width: 100%;
  padding-bottom: 1rem;
  border-bottom: solid 1px ${(props) => props.theme.colors.gray300};
  text-align: center;
  font-size: 2.5rem;
  font-family: 'Bossa Bold', sans-serif;
  color: ${(props) => props.theme.colors.violet500};

  @media ${(props) => props.theme.breakpoints.tablet} {
    font-size: 2rem;
  }
`;
